import http from '../../config/axios';

export const getAccount = async() => {
    const res = await http.get('/user/account')
    return res.data;
}

export const patchAccount= async(data) => {
    const res = await http.patch('/user/account', data)
    return res.data;
}

export const getImg = async(nameFile) => {
    try{
        const res = await http.get(`/user/account/img/${nameFile}`)
        return res.data;
    } catch(error) {
        return null;
    }    
}

export const postImgAccount = async(file, extension, type) => {
    const res = await http.post('/user/account/img', {file, extension, type})
    return res.data;
}